<div class="le-root">

  <!-- Canvas partículas -->
  <canvas #leCanvas class="le-canvas"></canvas>

  <!-- Loading overlay -->
  <div *ngIf="(loginFacade.responseLoading$ | async)?.loading" class="le-loading">
    <div class="le-spin-wrap">
      <div class="le-comet"></div>
      <p class="le-spin-lbl">Verificando credenciales...</p>
    </div>
  </div>

  <!-- Card split layout -->
  <div class="le-card">

    <!-- Panel izquierdo: Branding -->
    <div class="le-brand">
      <div class="le-brand-content">

        <span class="le-chip">
          <span class="le-chip-dot"></span>
          Inicio de Sesión
        </span>

        <div class="le-hero">
          <h1 class="le-hero-title">PORTAL ESTUDIANTIL</h1>
          <p class="le-hero-sub">Universidad Nacional Autónoma de Honduras</p>
        </div>

        <div class="le-progs">
          <div class="le-prog">
            <mat-icon class="le-prog-icon">school</mat-icon>
            <div class="le-prog-info">
              <span class="le-prog-name">Maestría</span>
              <span class="le-prog-desc">Especialización avanzada</span>
            </div>
          </div>
          <div class="le-prog">
            <mat-icon class="le-prog-icon">menu_book</mat-icon>
            <div class="le-prog-info">
              <span class="le-prog-name">Doctorado</span>
              <span class="le-prog-desc">Investigación de alto nivel</span>
            </div>
          </div>
          <div class="le-prog">
            <mat-icon class="le-prog-icon">workspace_premium</mat-icon>
            <div class="le-prog-info">
              <span class="le-prog-name">Especialidad</span>
              <span class="le-prog-desc">Formación profesional</span>
            </div>
          </div>
        </div>


      </div>
    </div>

    <!-- Panel derecho: Formulario -->
    <div class="le-panel">
      <div class="le-panel-bar"></div>

      <div class="le-panel-inner">

        <img src="../../../../assets/images/logo/logo-unah.png" alt="UNAH" class="le-logo" draggable="false">

        <div class="le-form-head">
          <h2 class="le-form-title">Bienvenido</h2>
          <p class="le-form-role">Estudiante de Posgrado</p>
          <p class="le-form-sub">
            <mat-icon class="le-sub-icon">shield</mat-icon>
            Ingresa tus credenciales para acceder al portal de posgrados
          </p>
        </div>

        <form ngNativeValidate [formGroup]="formLogin" (ngSubmit)="login()" class="le-form">

          <mat-form-field appearance="outline" class="le-field">
            <mat-label>Número de cuenta / Usuario</mat-label>
            <input matInput formControlName="usuario" required autocomplete="off"
              (keydown.enter)="$event.preventDefault()" (keypress)="allowAlphanumeric($event)"
              (keydown)="onUsuarioKeydown($event)"
              (input)="onUsuarioInput()">
            <mat-icon matSuffix>badge</mat-icon>
          </mat-form-field>

          <div class="le-pass-warn" *ngIf="usuarioFirstCharWarning || (formLogin.get('usuario')?.hasError('startsWithM') && formLogin.get('usuario')?.touched)">
            <mat-icon class="le-pass-warn-icon">warning_amber</mat-icon>
            El número de cuenta debe iniciar con la letra m
          </div>

          <mat-form-field appearance="outline" class="le-field">
            <mat-label>Contraseña</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'"
              formControlName="password" required autocomplete="off">
            <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
              [attr.aria-label]="'Mostrar contraseña'" [attr.aria-pressed]="hide">
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>

          <div class="le-actions">
            <button mat-button type="button" class="le-btn-back" (click)="volver()">
              <mat-icon>arrow_back_ios</mat-icon> Volver
            </button>
            <button mat-raised-button type="submit" class="le-btn-submit"
              [disabled]="(loginFacade.responseLoading$ | async)?.loading">
              <ng-container *ngIf="!(loginFacade.responseLoading$ | async)?.loading; else leLoadTpl">
                Ingresar &nbsp;<mat-icon>east</mat-icon>
              </ng-container>
              <ng-template #leLoadTpl>
                <mat-spinner diameter="22" strokeWidth="3"></mat-spinner>
              </ng-template>
            </button>
          </div>

        </form>

        <p class="le-footer">UNAH &copy; {{ year }} &middot; Portal de Posgrados</p>
      </div>
    </div>

  </div>

</div>
